import React, {useState, useEffect} from 'react';
import EditorFile from './EditorFile';

const EditorFileRow = ({articleId=null, files, setFiles=null, isAdminArticlePage=false}) => {

  return (
    <div className="file-list-section">
      {files.map((file) => {
        return (
          <EditorFile
            key={file.id}
            articleId={articleId} 
            file={file}
            setFiles={setFiles}
            isAdminArticlePage={isAdminArticlePage}
          />
        )
      })}
    </div>
  );
};

export default EditorFileRow;